import mutations from './eventRegistration.mutations'
import actions from './eventRegistration.actions'
import getters from './eventRegistration.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
